import cn from 'classnames'
import Link from 'next/link'

export default function CoverImage({ title, url, slug, isMain, extraClass }) {

    const image = (
        <img
            style={{ maxHeight: isMain ? "40rem" : "100% !important" }}
            src={url}
            alt={`Cover Image for ${title}`}
            className={`${cn('shadow-small', {
                'hover:shadow-medium transition-shadow duration-200 rounded-md': slug,
            })} ${extraClass}`}
        />
    )

    return (slug ? (<Link as={`/insights/${slug}`} href="/insights/[slug]" aria-label={title}>

        {image}

    </Link>) : image);
}